import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '../../../components/ui/avatar';
import TeamRolesRadarChart from '../../Talent/components/RadarChart';
import { Link } from 'react-router-dom';

const ChatTalentCard = ({ content }) => {
  const talent = content;
  if (!talent) return null;
  return (
    <div
      className="
        bg-gradient-to-br from-background via-muted/80 to-background/80
        border-2 border-border/30 dark:border-border/40
        rounded-3xl shadow-xl
        transition-all duration-200
        group relative overflow-hidden
        flex flex-col items-center
        p-8
        hover:border-[conic-gradient(at_top_left,_#f7baff,_#7ed7fa,_#a8ffce,_#f7baff)]
        backdrop-blur-md
      "
      style={{
        borderImage: 'none',
      }}
    >
      <div className="relative mb-4">
        <Avatar className="h-24 w-24 shadow-lg border-4 border-primary/30 group-hover:border-primary transition-all duration-200">
          <AvatarImage src={talent.profilePicture || '/default-avatar.png'} alt={talent.name} />
          <AvatarFallback>{talent.name?.[0] || '?'}</AvatarFallback>
        </Avatar>
        <div className="absolute -inset-1 rounded-full blur-lg opacity-40 bg-gradient-to-tr from-primary/60 to-secondary/40 pointer-events-none" />
      </div>
      <div className="font-extrabold text-2xl mb-1 text-center text-foreground group-hover:text-primary transition-colors duration-200">
        {talent.name}
      </div>
      

      <Link
        to={`/app/talents/${talent.id}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary underline text-xs mb-3 hover:text-primary/80 transition-colors font-medium"
      >
        Näytä profiili
      </Link>
      {/* Team roles: radar chart only, no badges */}
      {talent.teamRoles || talent.teamrole ? (
        <div className="w-full my-3 flex flex-col items-center">
          <div className="bg-primary/10 rounded-xl p-2 shadow-inner w-full flex flex-col items-center mb-2">
            <TeamRolesRadarChart
              teamRoles={talent.teamRoles || talent.teamrole}
              favoriteColor="#bbb"
              title="Tiimiroolit"
            />
          </div>
        </div>
      ) : (
        <div className="w-full my-3 flex flex-col items-center">
          <div className="text-xs text-muted-foreground italic">Ei tiimiroolitietoja</div>
        </div>
      )}
      {/* Skills as badges */}
      <div className="mb-3 w-full flex flex-col items-center">
        <span className="font-semibold text-sm mb-1 text-foreground">Taidot:</span>
        <div className="relative w-full max-h-24 overflow-y-auto scrollbar-thin scrollbar-thumb-primary/20 scrollbar-track-transparent">
          <div className="flex flex-wrap gap-2 justify-center">
            {talent.skills && talent.skills.map((skill, idx) => (
              <span
                key={skill.skill || idx}
                className="bg-gradient-to-r from-primary/10 to-secondary/10 text-primary px-2 py-1 rounded-full text-xs font-medium border border-primary/20 shadow-sm"
              >
                {skill.skill || skill}
                {skill.rating && ` (tasolla ${skill.rating})`}
              </span>
            ))}
          </div>
        </div>
      </div>
      {/* Description */}
      
    </div>
  );
};

export default ChatTalentCard; 